"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgSmartHome(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M33 15v19a2 2 0 01-2 2H9a2 2 0 01-2-2V15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M1.453 17.468L18.88 5.752a2 2 0 012.236.004l17.315 11.712M17.007 18.089a5.575 5.575 0 00-2.607 4.72A5.596 5.596 0 0020 28.4c3.093 0 5.6-2.504 5.6-5.591a5.575 5.575 0 00-2.596-4.713M20 21.6v-6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgSmartHome;
//# sourceMappingURL=SmartHome.js.map